import { put, takeEvery } from 'redux-saga/effects';

import { PermissionAction } from '../actions';
import { PermissionConstant } from '../constants';

export default function* () {
  yield takeEvery(
    PermissionConstant.GET_PERMISSIONS_SUCCESS,
    getPermissionsSuccess,
  );
}

function* getPermissionsSuccess(action) {
  yield put(PermissionAction.setPermissions(action?.payload));
}
